import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SeedDataFileParams {
  file: File;
}

export interface SeedDataFileResponse {
  message: string;
  sourceFileId: string;
}

const uploadSeedDataFile: MutationFunction<
  SeedDataFileResponse,
  SeedDataFileParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockUploadSourceFile, { delay: 100 });

  const formData = new FormData();
  formData.append('file', args.file);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SeedDataFileResponse>(
    `/seed/encompass/upload-mappings`,
    {
      method: 'POST',
      body: formData,
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to upload seed data');
};

export default uploadSeedDataFile;

const _mockUploadSourceFile = {
  message: 'Seed data uploaded successfully',
  sourceFileId: 'e727ftx2ctfasa91bun9p38f',
};
